import { HTMLELEMENT } from '../../../../../EL/EL.js';
import COLUMN from '../../../../../DOM/table/TGROUP/ROW/column/COLUMN.js';
import { makeStruct } from '../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../enums/ModelData.js';
import { COLUMNTYPE } from '../../../../../../enums/COLUMNTYPE.js';
// Model Structure
export const thAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['colspan'], // Default colspan is 1
    ['rowspan'] // Default rowspan is 1
]);
export const thData = makeDataStruct([
    ['text'],
    ['datatype', COLUMNTYPE.VARCHAR], // Default data type is string
    ['length', 255], // Default length for VARCHAR
]);
export const thModel = makeStruct([
    ['attributes', thAttr],
    ['data', thData]
]);
// Simplified Model
export function th(text, name, className, colspan, rowspan, datatype, length) {
    return {
        attributes: thAttr(name, className, colspan, rowspan),
        data: thData(text, datatype, length)
    };
}
/** A Row that exists inside a table group */
export default class TH extends COLUMN {
    constructor(node, model) {
        super(node, HTMLELEMENT.TH, model);
    }
}
